export const config = {
  baseURL: 'https://revit8apps.netlify.app/.netlify/functions',
  products: '/products',
  pageSize: 10,
  advertIndex: 5,
  delay: 200,
  clientId:
    '90003418335-a9sv8077jr4ue96okgblus5r9fcqro1a.apps.googleusercontent.com',
};
